import type {TiledImageManager} from "@cm/browser-utils"
import type {ImageTilesDescriptor} from "@cm/utils"
import {ThreeTiledTexture, type ThreeTiledTextureCallback} from "@cm/three-texture-streaming"

export async function createThreeTiledTexture(
    callback: ThreeTiledTextureCallback & {getTiledImageManager(): TiledImageManager},
    id: number,
    imageTilesDescriptor: ImageTilesDescriptor,
    isSrgb: boolean,
): Promise<ThreeTiledTexture> {
    await callback.getTiledImageManager().createTiledImage(imageTilesDescriptor)
    return new ThreeTiledTexture(callback, id, imageTilesDescriptor, isSrgb)
}
